import { type FC, useCallback } from 'react';

import { useMortgageCalculatorContext } from '../../contexts/MortgageCalculatorContext';
import { type IBank } from '../../types/bank';

import { AccreditedBanks } from './AccreditedBanks';
import { trackAccreditedBanksToListingClick } from './internal/tracking/trackAccreditedBanksToListingClick';

export const AccreditedBanksContainer: FC = () => {
  const { banks } = useMortgageCalculatorContext();

  const handleBankClick = useCallback<(bank: IBank) => void>(bank => {
    trackAccreditedBanksToListingClick(bank);
  }, []);

  if (!banks.length) {
    return null;
  }

  return <AccreditedBanks banks={banks} onBankClick={handleBankClick} />;
};
